/* ==========================================================================
   Back In Stock trigger placement
   --------------------------------------------------------------------------
   WHY THIS IS JS AND NOT LIQUID:
   #BIS_trigger does not exist in the server-rendered HTML. Verified against
   402KB of product-page source: zero occurrences. The Back In Stock app
   creates the button client-side and appends it high up inside
   <product-content>, above the size picker, which reads backwards -
   "Out of stock -> GET NOTIFIED -> now choose your size".

   There is no template to reorder, so the node is relocated after the app
   creates it. CSS `order` was tried first and rejected: making
   <product-content> a flex container reorders every sibling and pushed the
   button ~500px down the page.

   WHAT IT DOES:
   - Moves #BIS_trigger to sit immediately before section#xpurchase, i.e. the
     slot the Add to cart button normally occupies.
   - While the button is showing, hides the .cartButton in that section. On a
     sold-out variant it is disabled and still reads "Select size", so it is
     dead UI sitting under a live call to action. Only that one button is
     hidden - never the form, the error region or the payment buttons.
   - Restores the Add to cart button the moment an in-stock variant is chosen.

   Re-runs on AJAX variant swaps via MutationObserver, because the theme
   changes variants without a page reload.

   NOTE ON SCHEDULING: this used requestAnimationFrame to coalesce mutations.
   rAF does not fire in a background tab, so a product page opened in a
   background tab kept the button in the wrong place until the tab was
   focused. setTimeout always fires, so it is used instead.
   ========================================================================== */

(function () {
    'use strict';

    if (document.body.getAttribute('coretex-page') !== 'product') return;

    var pending = null;

    function sync() {
        pending = null;

        var btn = document.getElementById('BIS_trigger');
        var purchase = document.getElementById('xpurchase');
        if (!btn || !purchase || !purchase.parentElement) return;
        if (btn.parentElement !== purchase.parentElement) return;

        // The app toggles the button by display, so measure rather than assume.
        var showing = btn.offsetParent !== null && btn.getBoundingClientRect().height > 0;
        var addToCart = purchase.querySelector('.cartButton');

        if (showing) {
            if (btn.nextElementSibling !== purchase) {
                purchase.parentElement.insertBefore(btn, purchase);
            }
            if (addToCart && addToCart.style.display !== 'none') {
                addToCart.style.display = 'none';
            }
        } else if (addToCart && addToCart.style.display === 'none') {
            addToCart.style.display = '';
        }
    }

    // Coalesce bursts of mutations into one pass. sync() only writes when a
    // value actually differs, so observing our own writes converges.
    function schedule() {
        if (pending === null) pending = setTimeout(sync, 0);
    }

    function start() {
        var host = document.querySelector('.bullet-product-content product-content') || document.body;

        new MutationObserver(schedule).observe(host, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        document.addEventListener('change', function (e) {
            if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
        }, true);

        // The app may create the button after this script runs and without
        // mutating anything the observer is watching, so poll briefly on load.
        var tries = 0;
        var poll = setInterval(function () {
            schedule();
            if (++tries > 20) clearInterval(poll);
        }, 250);

        schedule();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
